import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { Trash2Icon } from "lucide-react";
import { EmailTemplate } from "@type/setting";

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    template: EmailTemplate | null;
    onConfirmDelete: (template: EmailTemplate) => void;
}

export default function TemplateDeleteDialog(props: Props) {
    const handleDelete = () => {
        if (props.template) {
            props.onConfirmDelete(props.template);
            props.onOpenChange(false);
        }
    };

    if (!props.template) return null;

    return (
        <Dialog open={props.open} onOpenChange={props.onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader className="pb-4">
                    <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                                <Trash2Icon className="h-5 w-5 text-red-600" />
                            </div>
                        </div>
                        <div className="flex-1 pt-1">
                            <DialogTitle className="text-lg font-semibold text-gray-900 mb-2">
                                Delete Template
                            </DialogTitle>
                        </div>
                    </div>
                </DialogHeader>

                <div className="pb-4">
                    <div className="text-sm text-gray-600 space-y-4">
                        <p>
                            Are you sure you want to delete the template{" "}
                            <span className="font-semibold text-gray-900">
                                "{props.template.template_name}"
                            </span>
                            ? This action cannot be undone.
                        </p>
                        {props.template.is_default && (
                            <p className="text-sm text-gray-600">
                                This is the default template for this category. Deleting it will
                                remove the default setting.
                            </p>
                        )}
                    </div>
                </div>

                <DialogFooter className="flex gap-3 sm:gap-2">
                    <Button
                        variant="outline"
                        onClick={() => props.onOpenChange(false)}
                        className="flex-1 sm:flex-none"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleDelete}
                        className="flex-1 sm:flex-none"
                    >
                        Delete Template
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
